// Toggle the `muted` flag on the current user's chat_channel_members row.
// Muted conversations suppress mention notifications, dim the unread badge,
// and show a bell-slash icon next to the title.
import { getSDK } from '@symbo-ls/workspace-shared/functions/sdk.js'
import { sameWorkspaceWriter } from './sameWorkspaceWriter.js'

export const setChannelMute = async function (channelId, muted) {
  const root = this.state.root
  const me = root?.currentUserEmail
  if (!channelId || !me) return false
  // `channelMembers` is workspace-scoped and this reconcile lands after the
  // mute round-trip — captured on the click tick so a mute issued in workspace
  // A cannot rewrite workspace B's membership rows.
  const _write = sameWorkspaceWriter(root)
  try {
    // migrated 2026-04-27 to SDK route workspaceProject.chat.members mute
    await getSDK().execute('workspaceProject.chat.members', 'mute', {
      channelId,
      userId: me,
      muted: !!muted
    })
    // Optimistic state reconcile — realtime will deliver the same row.
    const cur = root.channelMembers || []
    const next = cur.map((r) =>
      r.channel_id === channelId && r.member_email === me
        ? { ...r, muted: !!muted }
        : r
    )
    _write({ channelMembers: next })
    return true
  } catch (err) {
    console.error('[setChannelMute]', err)
    return false
  }
}

export const toggleChannelMute = async function (channelId) {
  const root = this.state.root
  const me = root?.currentUserEmail
  const cur = (root?.channelMembers || []).find(
    (r) => r.channel_id === channelId && r.member_email === me
  )
  return setChannelMute.call(this, channelId, !cur?.muted)
}

// Is the conversation muted for the current viewer? Used by the sidebar row
// styles and the realtime notification gate.
export const isChannelMuted = (root, channelId) => {
  if (!root || !channelId) return false
  const me = root.currentUserEmail
  const row = (root.channelMembers || []).find(
    (r) => r.channel_id === channelId && r.member_email === me
  )
  return !!row?.muted
}
